import { Badge, styled } from '@mui/material'

export const StyledBadge = styled(Badge)({
  right: 17,
  top: '50%',
})
